import type { FaireProductEntity } from "../../entity_types/product";

export const p_sb84sw8grh: FaireProductEntity = {
  token: "p_sb84sw8grh",
  type: "product",
  name: "o holy night watercolor wall art print",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/71e66bf2317f31fba8ef8e535c4bbd38fa0d4bb60fa4f552cb721af0fb434464.jpeg",
  galleryImageUrls: [],
  priceDollars: 11,
  description:
    'Add a festive touch to your home this Christmas season with the O Holy Night watercolor print.\n\nDetails: \n\n- 8"x10" print of original watercolor artwork by Emily Lex\n- Printed in full color on thick, superfine paper\n- Packaged in a clear protective sleeve with chipboard backing\n- Frame and mat not included\n',
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:15:08.507Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
